'use client'

import { UserProfileSection } from './sections/user-profile-section'

export const UserTab = () => {
    return (
        <div className="flex flex-col gap-6">
            <UserProfileSection />
        </div>
    )
}
